class SortPillsRow extends HTMLElement {
  connectedCallback() {
    const list = this.querySelector('.sort-pills__list');
    const active = this.querySelector('.sort-pills__pill--active');
    if (!list || !active) return;

    const pillRect = active.getBoundingClientRect();
    const listRect = list.getBoundingClientRect();
    const offset = pillRect.left - listRect.left - (listRect.width - pillRect.width) / 2;
    list.scrollLeft = offset;
  }
}

if (!customElements.get('sort-pills-row')) {
  customElements.define('sort-pills-row', SortPillsRow);
}
